// removed by extract-text-webpack-plugin
module.exports = {"container_404":"_7p_syGgePtJhx-Rb_SLPB","logo_digidocteur":"_1jLRXfcryZklXg6b7ElOcM","container_img":"_3l9wwZP0L10vkiSlU9RLja","title_text_404":"_2gk9cuxyTXzHo7XnkIGlXX","text_404":"WPiod_kgW-LfxTYP_deB1","btn_404":"_2o5kTzaO3eILJwopryxwMq","title_text_404__20X6g":"_2sDzWb8LbPPKdRsx2sjpPW","bobble":"_3epZ-E__BO1WsBn5JeeQZ9"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/patientplaylist/404Page/404.scss
// module id = 1643
// module chunks = 0